import styled from 'styled-components';

export const CardWrapper = styled.div<{ $isHighPriority: boolean }>`
  padding: 10px;
  cursor: pointer;
  background: transparent;
  border: 1px solid var(--clr-border-grey-100);
  border-radius: 5px;
  .icon-wrapper {
    font-size: 18px;
    color: var(--clr-icon-color);
    flex-shrink: 0;
  }

  .priority-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: var(--clr-general-primary);
  }

  .arrow-icon {
    color: var(--clr-general-description);
    font-size: 20px;
    flex-shrink: 0;
  }
`;
